// import React, { useState } from "react";
// import {
//   FaTachometerAlt,
//   FaUsers,
//   FaUserCheck,
//   FaCog,
//   FaSignOutAlt,
//   FaBars,
// } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";

// function Sidebar() {
//   const [active, setActive] = useState("dashboard");
//   const [open, setOpen] = useState(true);
//     const navigate = useNavigate();
//   return (
//     <div style={{ display: "flex" }}>
      
//       {/* SIDEBAR */}
//       <div
//         style={{
//           width: open ? "240px" : "70px",
//           height: "100vh",
//           background: "#1b2a2f",
//           color: "#fff",
//           transition: "0.3s",
//           padding: "15px 10px",
//           position: "fixed",
//         }}
//       >
//         {/* TOGGLE */}
//         <div
//           style={{
//             display: "flex",
//             justifyContent: open ? "space-between" : "center",
//             alignItems: "center",
//             marginBottom: "20px",
//           }}
//         >
//           {open && <h5 style={{ margin: 0 }}>Admin</h5>}
//           <FaBars
//             style={{ cursor: "pointer" }}
//             onClick={() => setOpen(!open)}
//           />
//         </div>

//         {/* MENU */}
//         <MenuItem
//           icon={<FaTachometerAlt />}
//           label="Dashboard"
//           active={active === "dashboard"}
//           open={open}
//           onClick={() => setActive("dashboard")}
//         />

//         <MenuItem
//           icon={<FaUsers />}
//           label="Users"
//           active={active === "users"}
//           open={open}
//           onClick={() => setActive("users")}
//         />

//         <MenuItem
//           icon={<FaUserCheck />}
//           label="Review"
//           active={active === "review"}
//           open={open}
//           onClick={() => setActive("review")}
//         />

//         <MenuItem
//           icon={<FaCog />}
//           label="Settings"
//           active={active === "settings"}
//           open={open}
//           onClick={() => setActive("settings")}
//         />

//         {/* LOGOUT */}
// <div style={{ position: "absolute", bottom: "20px", width: "90%" }}>
//   <MenuItem
//     icon={<FaSignOutAlt />}
//     label="Logout"
//     active={false}
//     open={open}
//     onClick={() => {
//       localStorage.removeItem("admin");
//       navigate("/admin-login");
//            window.location.reload();
//     }}
//   />
// </div>
//       </div>

//       {/* MAIN CONTENT PLACEHOLDER */}

//     </div>
//   );
// }

// /* 🔥 MENU ITEM COMPONENT */
// const MenuItem = ({ icon, label, active, open, onClick }) => {
//   return (
//     <div
//       onClick={onClick}
//       style={{
//         display: "flex",
//         alignItems: "center",
//         gap: "12px",
//         padding: "10px",
//         borderRadius: "10px",
//         marginBottom: "10px",
//         cursor: "pointer",
//         background: active ? "#0bbd9d" : "transparent",
//         color: active ? "#fff" : "#cbd5e1",
//         transition: "0.2s",
//       }}
//     >
//       <div style={{ fontSize: "18px" }}>{icon}</div>
//       {open && <span>{label}</span>}
//     </div>
//   );
// };

// export default Sidebar;

// import React, { useState } from "react";
// import {
//   FaTachometerAlt,
//   FaUsers,
//   FaUserCheck,
//   FaCog,
//   FaSignOutAlt,
//   FaBars,
// } from "react-icons/fa";
// import { useNavigate, Outlet } from "react-router-dom";
// import logo from "../../Images/logo2.png";
// import "../../App.css";

// function Sidebar() {
//   const [active, setActive] = useState("dashboard");
//   const [open, setOpen] = useState(true);
//   const navigate = useNavigate();

//   return (
//     <div style={{ display: "flex" }}>
      
//       {/* SIDEBAR */}
//       <div

//         style={{
//           width: open ? "240px" : "70px",
//           height: "100vh",
//           background: "#f4f6f7",
//           color: "#fff",
//           transition: "0.3s",
//           padding: "15px 10px",
//             borderRight: "2px dotted #c7cfD6", 
          
//           position: "fixed",
//         }}
//       >
//        <div
//   style={{
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     marginBottom: "20px",
//     position: "relative",
//   }}
// >
//   {open && (
//     <img
//       src={logo}
//       alt="logo"
//       style={{ height: "110px", objectFit: "contain" }}
//     />
//   )}
// {/* 
//   <FaBars
//     onClick={() => setOpen(!open)}
//     style={{
//       cursor: "pointer",
//       position: "absolute",
//       right: "10px",
//       color:"#0a0a0a"
//     }}
//   /> */}

//   {/* <FaBars
//   onClick={() => setOpen(!open)}
//   style={{
//     position: "fixed",
//     top: "20px",
//     left: open ? "250px" : "80px", // sidebar ke hisab se move karega
//     cursor: "pointer",
//     zIndex: 1000,
//     fontSize: "20px",
//     color: "#0a0a0a",
//     transition: "0.3s",
//   }}
// /> */}
// <FaBars
//   onClick={() => setOpen(!open)}
//   style={{
//     position: "fixed",
//     top: "20px",
//     left: open ? "250px" : "80px",
//     cursor: "pointer",
//     zIndex: 1000,
//     fontSize: "20px",
//     color: "#0a0a0a",
//     transition: "0.3s",
//   }}
//   onMouseEnter={(e) => {
//     e.currentTarget.style.color = "#a47148"; 
//   }}
//   onMouseLeave={(e) => {
//     e.currentTarget.style.color = "#0a0a0a";
//   }}
// />
// </div>
//         {/* MENU */}
//         <MenuItem
//           icon={<FaTachometerAlt />}
//           label="Dashboard"
//           active={active === "dashboard"}
//           open={open}
//           onClick={() => {
//             setActive("dashboard");
//             navigate("/admin/dashboard");
//           }}
//         />

//         <MenuItem
//           icon={<FaUsers />}
//           label="Manage Projects"
//           active={active === "Manage Projects"}
//           open={open}
//           onClick={() =>{ setActive("Manage Projects");
//            navigate("/admin/manage-projects");
//           }}
//         />

//         <MenuItem
//           icon={<FaUserCheck />}
//           label="Project Completion"
//           active={active === "project completion"}
//           open={open}
//           onClick={() => {setActive("project completion");
//                  navigate("/admin/project-completion");
//         }}
//         />

//         <MenuItem
//           icon={<FaCog />}
//           label="Manage-staff"
//           active={active === "Manage-staff"}
//           open={open}
//           onClick={() => {setActive("Manage-staff");
//               navigate("/admin/manage-staff");

//           }}
//         />

//         {/* LOGOUT */}
//         <div style={{ position: "absolute", bottom: "20px", width: "90%" }}>
//           <MenuItem
//             icon={<FaSignOutAlt />}
//             label="Logout"
//             open={open}
//             onClick={() => {
//               localStorage.removeItem("admin");
//               navigate("/admin-login");
//               window.location.reload();
//             }}
//           />
//         </div>
//       </div>

//       {/* CONTENT AREA */}
// <div
//   className="main-content"   
//   style={{
//     marginLeft: open ? "240px" : "70px",
//   }}
// >
//   <Outlet />
// </div>
//     </div>
//   );
// }

// const MenuItem = ({ icon, label, active, open, onClick }) => (
//   <div
//     onClick={onClick}
//     style={{
//       display: "flex",
//       alignItems: "center",
//       gap: "12px",
//       padding: "10px",
//       borderRadius: "10px",
//       marginBottom: "10px",
//       cursor: "pointer",
//       background: active ? "#d4c2bb" : "transparent",
//       color: active ? "#704B3c" : "#363636",
//     }}
//   >
//     <div>{icon}</div>
//     {open && <span>{label}</span>}
//   </div>
// );

// export default Sidebar;



// import React, { useState } from "react";
// import {
//   FaTachometerAlt,
//   FaUsers,
//   FaUserCheck,
//   FaCog,
//   FaSignOutAlt,
//   FaAngleRight,
//   FaAngleLeft,
// } from "react-icons/fa";
// import { useNavigate, Outlet } from "react-router-dom";
// import logo from "../../Images/logo2.png";
// import "../../App.css";
// import { MdAssignmentTurnedIn } from "react-icons/md";

// function Sidebar() {
//   const [active, setActive] = useState("dashboard");
//   const [open, setOpen] = useState(true);
//   const navigate = useNavigate();

//   return (
//     <div style={{ display: "flex" }}>
      
//       {/* SIDEBAR */}
//       <div
//         style={{
//           width: open ? "240px" : "70px",
//           height: "100vh",
//           background: "#f4f6f7",
//           color: "#fff",
//           transition: "0.3s",
//           padding: "15px 10px",
//           borderRight: "2px dotted #c7cfD6",
//           position: "fixed",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             marginBottom: "20px",
//             position: "relative",
//           }}
//         >
//           {open && (
//             <img
//               src={logo}
//               alt="logo"
//               style={{ height: "110px", objectFit: "contain" }}
//             />
//           )}

//          {open ? (
//   <FaAngleLeft
//     onClick={() => setOpen(false)}
//     style={{
//       position: "absolute",
//       right: "10px",
//       cursor: "pointer",
//       fontSize: "20px",
//       color: "#0a0a0a",
//       transition: "0.3s",
//     }}
//     onMouseEnter={(e) => {
//       e.currentTarget.style.color = "#a47148";
//     }}
//     onMouseLeave={(e) => {
//       e.currentTarget.style.color = "#0a0a0a";
//     }}
//   />
// ) : (
//   <FaAngleRight
//     onClick={() => setOpen(true)}
//     style={{
//       position: "absolute",
//       right: "10px",
//       cursor: "pointer",
//       fontSize: "20px",
//       color: "#0a0a0a",
//       transition: "0.3s",
//     }}
//     onMouseEnter={(e) => {
//       e.currentTarget.style.color = "#a47148";
//     }}
//     onMouseLeave={(e) => {
//       e.currentTarget.style.color = "#0a0a0a";
//     }}
//   />
// )}
//         </div>

      
//         <MenuItem
//           icon={<FaTachometerAlt />}
//           label="Dashboard"
//           active={active === "dashboard"}
//           open={open}
//           onClick={() => {
//             setActive("dashboard");
//             navigate("/admin/dashboard");
//           }}
//         />

//         <MenuItem
//           icon={<FaUsers />}
//           label="Manage Projects"
//           active={active === "Manage Projects"}
//           open={open}
//           onClick={() => {
//             setActive("Manage Projects");
//             navigate("/admin/manage-projects");
//           }}
//         />

//         <MenuItem
//           icon={<FaUserCheck />}
//           label="Project Completion"
//           active={active === "project completion"}
//           open={open}
//           onClick={() => {
//             setActive("project completion");
//             navigate("/admin/project-completion");
//           }}
//         />

//         <MenuItem
//           icon={<FaCog />}
//           label="Manage-staff"
//           active={active === "Manage-staff"}
//           open={open}
//           onClick={() => {
//             setActive("Manage-staff");
//             navigate("/admin/manage-staff");
//           }}
//         />
//   <MenuItem
//           icon={<MdAssignmentTurnedIn />}
//           label="project-alloted"
//           active={active === "project-alloted"}
//           open={open}
//           onClick={() => {
//             setActive("project-alloted");
//             navigate("/admin/project-alloted");
//           }}
//         />
//         {/* LOGOUT */}
//         <div style={{ position: "absolute", bottom: "20px", width: "90%" }}>
//           <MenuItem
//             icon={<FaSignOutAlt />}
//             label="Logout"
//             open={open}
//             onClick={() => {
//               localStorage.removeItem("admin");
         
//     if (role === "admin") navigate("/admin-login");
//     else navigate("/");
//               window.location.reload();
//             }}
//           />
//         </div>
//       </div>

//       {/* CONTENT AREA */}
//       <div
//         className="main-content"
//         style={{
//           marginLeft: open ? "240px" : "70px",
//         }}
//       >
//         <Outlet />
//       </div>
//     </div>
//   );
// }

// const MenuItem = ({ icon, label, active, open, onClick }) => (
//   <div
//     onClick={onClick}
//     style={{
//       display: "flex",
//       alignItems: "center",
//       gap: "12px",
//       padding: "10px",
//       borderRadius: "10px",
//       marginBottom: "10px",
//       cursor: "pointer",
//       background: active ? "#d4c2bb" : "transparent",
//       color: active ? "#704B3c" : "#363636",
//     }}
//   >
//     <div>{icon}</div>
//     {open && <span>{label}</span>}
//   </div>
// );

// export default Sidebar;
// import React, { useState } from "react";
// import {
//   FaTachometerAlt,
//   FaUsers,
//   FaUserCheck,
//   FaCog,
//   FaSignOutAlt,
//   FaAngleRight,
//   FaAngleLeft,
//   FaExclamationTriangle,
// } from "react-icons/fa";
// import { useNavigate, Outlet } from "react-router-dom";
// import logo from "../../Images/logo2.png";
// import "../../App.css";
// import { MdAssignmentTurnedIn } from "react-icons/md";
// import { FaUserCog } from "react-icons/fa";

// function Sidebar({ admin }) {
//   const [active, setActive] = useState("dashboard");
//   const [open, setOpen] = useState(true);
//   const [showLogout, setShowLogout] = useState(false);
//   const navigate = useNavigate();
//   const role = admin?.role || "user";

//   return (
//     <div style={{ display: "flex" }}>

//       {/* SIDEBAR */}
//       <div
//         style={{
//           width: open ? "240px" : "70px",
//           height: "100vh",
//           background: "#f4f6f7",
//           transition: "0.3s",
//           padding: "15px 10px",
//           borderRight: "2px dotted #c7cfD6",
//           position: "fixed",
//         }}
//       >
//         {/* LOGO */}
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             marginBottom: "20px",
//             position: "relative",
//           }}
//         >
//           {open && (
//             <img
//               src={logo}
//               alt="logo"
//               style={{ height: "110px", objectFit: "contain" }}
//             />
//           )}

//           {open ? (
//             <FaAngleLeft onClick={() => setOpen(false)} style={arrowStyle} />
//           ) : (
//             <FaAngleRight onClick={() => setOpen(true)} style={arrowStyle} />
//           )}
//         </div>

//         {/* MENU */}
//         <MenuItem
//           icon={<FaTachometerAlt />}
//           label="Dashboard"
//           active={active === "dashboard"}
//           open={open}
//           onClick={() => {
//             setActive("dashboard");
//             navigate("/admin/dashboard");
//           }}
//         />

//         {admin?.role == "admin" && (
//           <MenuItem
//             icon={<FaUsers />}
//             label="Manage Projects"
//             active={active === "manage-projects"}
//             open={open}
//             onClick={() => {
//               setActive("manage-projects");
//               navigate("/admin/manage-projects");
//             }}
//           />
//         )}

//         {(admin?.role == "reviewer" || admin?.role == "admin") && (
//           <MenuItem
//             icon={<FaUserCheck />}
//             label="Project Completion"
//             active={active === "project-completion"}
//             open={open}
//             onClick={() => {
//               setActive("project-completion");
//               navigate("/admin/project-completion");
//             }}
//           />
//         )}

//         {admin?.role == "admin" && (
//           <MenuItem
//             icon={<FaCog />}
//             label="Manage Staff"
//             active={active === "manage-staff"}
//             open={open}
//             onClick={() => {
//               setActive("manage-staff");
//               navigate("/admin/manage-staff");
//             }}
//           />
//         )}

//         {admin?.role == "sitemaster" && (
//           <MenuItem
//             icon={<MdAssignmentTurnedIn />}
//             label="Project Alloted"
//             active={active === "project-alloted"}
//             open={open}
//             onClick={() => {
//               setActive("project-alloted");
//               navigate("/admin/project-alloted");
//             }}
//           />
//         )}

//         {/* LOGOUT */}
//         <div style={{ marginBottom: "10px" }}>
//           <MenuItem
//             icon={<FaSignOutAlt />}
//             label="Logout"
//             open={open}
//             onClick={() => setShowLogout(true)}
//           />
//         </div>
//       </div>

//       {/* MAIN CONTENT */}
//       <div
//         className="main-content"
//         style={{
//           marginLeft: open ? "240px" : "70px",
//         }}
//       >
//         <Outlet />
//       </div>

//       {/* ✅ MODERN LOGOUT MODAL WITH REACT ICONS */}
//       {showLogout && (
//         <div
//           className="modal show fade d-block"
//           tabIndex="-1"
//           style={{ background: "rgba(0,0,0,0.5)" }}
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div
//               className="modal-content"
//               style={{ borderRadius: "16px", overflow: "hidden" }}
//             >
//               {/* HEADER */}
//               <div
//                 className="modal-header"
//                 style={{
//                   background: "linear-gradient(135deg, #ff4b2b, #ff416c)",
//                   color: "#fff",
//                   borderBottom: "none",
//                 }}
//               >
//                 <h5 className="modal-title d-flex align-items-center gap-2">
//                   <FaExclamationTriangle />
//                   Confirm Logout
//                 </h5>

//                 <button
//                   type="button"
//                   className="btn-close btn-close-white"
//                   onClick={() => setShowLogout(false)}
//                 ></button>
//               </div>

//               {/* BODY */}
//               <div className="modal-body text-center" style={{ padding: "30px" }}>
//                 <div style={{ fontSize: "45px", color: "#ff4b2b" }}>
//                   <FaSignOutAlt />
//                 </div>

//                 <p style={{ fontSize: "16px", color: "#555", marginTop: "10px" }}>
//                   Are you sure you want to logout from your account?
//                 </p>
//               </div>

//               {/* FOOTER */}
//               <div
//                 className="modal-footer"
//                 style={{
//                   justifyContent: "center",
//                   borderTop: "none",
//                   paddingBottom: "25px",
//                   gap: "10px",
//                 }}
//               >
//                 <button
//                   className="btn btn-light"
//                   style={{
//                     borderRadius: "8px",
//                     padding: "8px 20px",
//                     border: "1px solid #ccc",
//                   }}
//                   onClick={() => setShowLogout(false)}
//                 >
//                   Cancel
//                 </button>

//                 <button
//                   className="btn d-flex align-items-center gap-2"
//                   style={{
//                     background: "linear-gradient(135deg, #ff4b2b, #ff416c)",
//                     color: "white",
//                     borderRadius: "8px",
//                     padding: "8px 20px",
//                     border: "none",
//                   }}
//                   onClick={() => {
//                     localStorage.removeItem("admin");

//                     if (role === "admin") {
//                       navigate("/admin-login");
//                     } else {
//                       navigate("/");
//                     }

//                     window.location.reload();
//                   }}
//                 >
//                   <FaSignOutAlt />
//                   Logout
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// /* Arrow */
// const arrowStyle = {
//   position: "absolute",
//   right: "10px",
//   cursor: "pointer",
//   fontSize: "20px",
//   color: "#0a0a0a",
// };

// /* Menu Item */
// const MenuItem = ({ icon, label, active, open, onClick }) => (
//   <div
//     onClick={onClick}
//     style={{
//       display: "flex",
//       alignItems: "center",
//       gap: "12px",
//       padding: "10px",
//       borderRadius: "10px",
//       marginBottom: "10px",
//       cursor: "pointer",
//       background: active ? "#d4c2bb" : "transparent",
//       color: active ? "#704B3c" : "#363636",
//     }}
//   >
//     <div>{icon}</div>
//     {open && <span>{label}</span>}
//   </div>
// );

// export default Sidebar;

// import React, { useState } from "react";
// import {
//   FaTachometerAlt,
//   FaUsers,
//   FaUserCheck,
//   FaCog,
//   FaSignOutAlt,
//   FaAngleRight,
//   FaAngleLeft,
//   FaExclamationTriangle,
// } from "react-icons/fa";
// import { useNavigate, Outlet } from "react-router-dom";
// import logo from "../../Images/logo2.png";
// import "../../App.css";
// import { MdAssignmentTurnedIn } from "react-icons/md";
// import { FaUserCog } from "react-icons/fa";

// function Sidebar({ admin }) {
//   const [active, setActive] = useState("dashboard");
//   const [open, setOpen] = useState(true);
//   const [showLogout, setShowLogout] = useState(false);
//   const navigate = useNavigate();
//   const role = admin?.role || "user";

//   return (
//     <div style={{ display: "flex" }}>

//       {/* SIDEBAR */}
//       <div
//         style={{
//           width: open ? "240px" : "70px",
//           height: "100vh",
//           background: "#f4f6f7",
//           transition: "0.3s",
//           padding: "15px 10px",
//           borderRight: "2px dotted #c7cfD6",
//           position: "fixed",
//         }}
//       >
//         {/* LOGO */}
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             marginBottom: "20px",
//             position: "relative",
//           }}
//         >
//           {open && (
//             <img
//               src={logo}
//               alt="logo"
//               style={{ height: "110px", objectFit: "contain" }}
//             />
//           )}

//           {open ? (
//             <FaAngleLeft onClick={() => setOpen(false)} style={arrowStyle} />
//           ) : (
//             <FaAngleRight onClick={() => setOpen(true)} style={arrowStyle} />
//           )}
//         </div>

//         {/* MENU */}
//         <MenuItem
//           icon={<FaTachometerAlt />}
//           label="Dashboard"
//           active={active === "dashboard"}
//           open={open}
//           onClick={() => {
//             setActive("dashboard");
//             navigate("/admin/dashboard");
//           }}
//         />

//         {admin?.role == "admin" && (
//           <MenuItem
//             icon={<FaUsers />}
//             label="Manage Projects"
//             active={active === "manage-projects"}
//             open={open}
//             onClick={() => {
//               setActive("manage-projects");
//               navigate("/admin/manage-projects");
//             }}
//           />
//         )}

//         {(admin?.role == "reviewer" || admin?.role == "admin") && (
//           <MenuItem
//             icon={<FaUserCheck />}
//             label="Project Completion"
//             active={active === "project-completion"}
//             open={open}
//             onClick={() => {
//               setActive("project-completion");
//               navigate("/admin/project-completion");
//             }}
//           />
//         )}

//         {admin?.role == "admin" && (
//           <MenuItem
//             icon={<FaCog />}
//             label="Manage Staff"
//             active={active === "manage-staff"}
//             open={open}
//             onClick={() => {
//               setActive("manage-staff");
//               navigate("/admin/manage-staff");
//             }}
//           />
//         )}

//         {admin?.role == "sitemaster" && (
//           <MenuItem
//             icon={<MdAssignmentTurnedIn />}
//             label="Project Alloted"
//             active={active === "project-alloted"}
//             open={open}
//             onClick={() => {
//               setActive("project-alloted");
//               navigate("/admin/project-alloted");
//             }}
//           />
//         )}

//         {/* LOGOUT */}
//         <div style={{ marginBottom: "10px" }}>
//           <MenuItem
//             icon={<FaSignOutAlt />}
//             label="Logout"
//             open={open}
//             onClick={() => setShowLogout(true)}
//           />
//         </div>
//       </div>

//       {/* MAIN CONTENT */}
//       <div
//         className="main-content"
//         style={{
//           marginLeft: open ? "240px" : "70px",
//         }}
//       >
//         <Outlet />
//       </div>

//       {/* ✅ MODERN LOGOUT MODAL WITH REACT ICONS */}
//       {showLogout && (
//         <div
//           className="modal show fade d-block"
//           tabIndex="-1"
//           style={{ background: "rgba(0,0,0,0.5)" }}
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div
//               className="modal-content"
//               style={{ borderRadius: "16px", overflow: "hidden" }}
//             >
//               {/* HEADER */}
//               <div
//                 className="modal-header"
//                 style={{
//                   background: "linear-gradient(135deg, #ff4b2b, #ff416c)",
//                   color: "#fff",
//                   borderBottom: "none",
//                 }}
//               >
//                 <h5 className="modal-title d-flex align-items-center gap-2">
//                   <FaExclamationTriangle />
//                   Confirm Logout
//                 </h5>

//                 <button
//                   type="button"
//                   className="btn-close btn-close-white"
//                   onClick={() => setShowLogout(false)}
//                 ></button>
//               </div>

//               {/* BODY */}
//               <div className="modal-body text-center" style={{ padding: "30px" }}>
//                 <div style={{ fontSize: "45px", color: "#ff4b2b" }}>
//                   <FaSignOutAlt />
//                 </div>

//                 <p style={{ fontSize: "16px", color: "#555", marginTop: "10px" }}>
//                   Are you sure you want to logout from your account?
//                 </p>
//               </div>

//               {/* FOOTER */}
//               <div
//                 className="modal-footer"
//                 style={{
//                   justifyContent: "center",
//                   borderTop: "none",
//                   paddingBottom: "25px",
//                   gap: "10px",
//                 }}
//               >
//                 <button
//                   className="btn btn-light"
//                   style={{
//                     borderRadius: "8px",
//                     padding: "8px 20px",
//                     border: "1px solid #ccc",
//                   }}
//                   onClick={() => setShowLogout(false)}
//                 >
//                   Cancel
//                 </button>

//                 <button
//                   className="btn d-flex align-items-center gap-2"
//                   style={{
//                     background: "linear-gradient(135deg, #ff4b2b, #ff416c)",
//                     color: "white",
//                     borderRadius: "8px",
//                     padding: "8px 20px",
//                     border: "none",
//                   }}
//                   onClick={() => {
//                     localStorage.removeItem("admin");

//                     if (role === "admin") {
//                       navigate("/admin-login");
//                     } else {
//                       navigate("/");
//                     }

//                     window.location.reload();
//                   }}
//                 >
//                   <FaSignOutAlt />
//                   Logout
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// /* Arrow */
// const arrowStyle = {
//   position: "absolute",
//   right: "10px",
//   cursor: "pointer",
//   fontSize: "20px",
//   color: "#0a0a0a",
// };

// /* Menu Item */
// const MenuItem = ({ icon, label, active, open, onClick }) => (
//   <div
//     onClick={onClick}
//     style={{
//       display: "flex",
//       alignItems: "center",
//       gap: "12px",
//       padding: "10px",
//       borderRadius: "10px",
//       marginBottom: "10px",
//       cursor: "pointer",
//       background: active ? "#d4c2bb" : "transparent",
//       color: active ? "#704B3c" : "#363636",
//     }}
//   >
//     <div>{icon}</div>
//     {open && <span>{label}</span>}
//   </div>
// );

// export default Sidebar;

import React, { useState, useEffect } from "react";
import {
  FaTachometerAlt,
  FaUsers,
  FaUserCheck,
  FaCog,
  FaSignOutAlt,
  FaAngleRight,
  FaAngleLeft,
  FaExclamationTriangle
} from "react-icons/fa";
import { MdManageAccounts } from "react-icons/md";
import { useNavigate, Outlet } from "react-router-dom";
import logo from "../../Images/logo2.png";
import "../../App.css";
import { MdAssignmentTurnedIn } from "react-icons/md";

function Sidebar({ admin }) {
  const [active, setActive] = useState("dashboard");
  const [open, setOpen] = useState(true);
  const [showLogout, setShowLogout] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
   const role = admin?.role || "user";

  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ display: "flex", width: "100%" }}>

    
      <div
        style={{
          width: open ? "240px" : "70px",
          height: "100vh",
          background: "#f4f6f7",
          transition: "0.3s",
          padding: "15px 10px",
          borderRight: "2px dotted #c7cfD6",
          position: "fixed",
          top: 0,
          left: isMobile ? (open ? "0" : "-240px") : "0",
          zIndex: 1000
        }}
      >

       
        {open ? (
          <FaAngleLeft onClick={() => setOpen(false)} style={arrowStyle(open, isMobile)} />
        ) : (
          <FaAngleRight onClick={() => setOpen(true)} style={arrowStyle(open, isMobile)} />
        )}


        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          {open && (
            <img
              src={logo}
              alt="logo"
              style={{ height: "100px" }}
            />
          )}
        </div>

  
        <MenuItem
          icon={<FaTachometerAlt   size={26}/>}
          label="Dashboard"
          open={open}
          active={active === "dashboard"}
          onClick={() => {
            setActive("dashboard");
            navigate("/admin/dashboard");
          }}
        />
{admin?.role == "admin" && (
        <MenuItem
          icon={<FaUsers  size={26}/>}
          label="Manage Projects"
          open={open}
          active={active === "projects"}
          onClick={() => {
            setActive("projects");
            navigate("/admin/manage-projects");
          }}
        />
)}
 {(admin?.role == "reviewer" || admin?.role == "admin") && (
        <MenuItem
          icon={<FaUserCheck size={26} />}
          label="Project Completion"
          open={open}
          active={active === "completion"}
          onClick={() => {
            setActive("completion");
            navigate("/admin/project-completion");
          }}
        />)}
 {admin?.role == "admin" && (
        <MenuItem
          icon={<MdManageAccounts size={26}/>}
          label="Manage Staff"
          open={open}
          active={active === "staff"}
          onClick={() => {
            setActive("staff");
            navigate("/admin/manage-staff");
          }}
        />
 )}
     {admin?.role == "sitemaster" && (
        <MenuItem
          icon={<MdAssignmentTurnedIn size={26} />}
          label="Project Alloted"
          open={open}
          active={active === "alloted"}
          onClick={() => {
            setActive("alloted");
            navigate("/admin/project-alloted");
          }}
        />)}

        <MenuItem
          icon={<FaSignOutAlt size={26} />}
          label="Logout"
          open={open}
          active={false}
          onClick={() => setShowLogout(true)}
        />
      </div>

      {isMobile && open && (
        <div
          onClick={() => setOpen(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.3)",
            zIndex: 999
          }}
        />
      )}


      <div
        className="main-content"
        style={{
          marginLeft: isMobile ? "0" : open ? "240px" : "70px",
          width: "100%"
        }}
      >
        <Outlet />
      </div>

     
      {showLogout && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.4)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 2000,
    }}
  >
    <div
      style={{
        background: "#fff",
        padding: "25px",
        borderRadius: "12px",
        width: "300px",
        textAlign: "center",
        boxShadow: "0 5px 20px rgba(0,0,0,0.2)",
      }}
    >
      <h4 style={{ marginBottom: "15px" }}>Confirm Logout?</h4>

      <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
        <button
          onClick={() => setShowLogout(false)}
          style={{
            padding: "8px 15px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            background: "#f5f5f5",
            cursor: "pointer",
          }}
        >
          Cancel
        </button>

        <button
          onClick={() => {
            // localStorage.removeItem("admin");
            // navigate("/admin-login");
            // window.location.reload();
            
  const user = JSON.parse(localStorage.getItem("admin"));

  localStorage.removeItem("admin");

  if (user?.role === "admin") {
    navigate("/admin-login");
  } else {
    navigate("/");
  }

  window.location.reload();
}}
  
          style={{
            padding: "8px 15px",
            borderRadius: "6px",
            border: "none",
            background: "#ff4b2b",
            color: "#fff",
            cursor: "pointer",
          }}
        >
          Logout
        </button>
      </div>
    </div>
  </div>
)}
    </div>
  );
}


const arrowStyle = (open, isMobile) => ({
  position: isMobile ? "fixed" : "absolute",
  left: isMobile ? (open ? "220px" : "10px") : "auto",
  right: isMobile ? "auto" : "-15px",
  top: "20px",
  background: "#D4C2BB",
  padding: "5px",
  borderRadius: "50%",
  cursor: "pointer",
  zIndex: 2000
});


const MenuItem = ({ icon, label, open, active, onClick }) => (
  <div
    onClick={onClick}
    style={{
      display: "flex",
      alignItems: "center",
      gap: "10px",
      padding: "10px",
      borderRadius: "8px",
      cursor: "pointer",
      background: active ? "#d4c2bb" : "transparent",
      color: active ? "#704B3c" : "#333",
      transition: "0.2s"
    }}
    onMouseEnter={(e) => {
      if (!active) e.currentTarget.style.background = "#eee";
    }}
    onMouseLeave={(e) => {
      if (!active) e.currentTarget.style.background = "transparent";
    }}
  >
    {icon}
    {open && <span>{label}</span>}
  </div>
);

export default Sidebar;
